export const CLEAR_FORGET_PASSWORD = "CLEAR_FORGET_PASSWORD";
export const CLEAR_FORGET_PASSWORD_SUCCESS = "CLEAR_FORGET_PASSWORD_SUCCESS";
export const CLEAR_FORGET_PASSWORD_FAILED = "CLEAR_FORGET_PASSWORD_FAILED";

export const FORGET_PASSWORD = "FORGET_PASSWORD";
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";
export const FORGET_PASSWORD_ERROR = "FORGET_PASSWORD_ERROR";
